import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BusinessLayout from './business/BusinessLayout';
import useBusiness, { fieldCls, primaryBtn, card } from './business/useBusiness';
import { bizApi } from '../lib/business';
import { useAuth } from '../contexts/AuthContext';

// /business: no company yet -> create one; otherwise straight to the rides.
export default function BusinessHome() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { loading, company, error } = useBusiness({ needCompany: false });
  const [name, setName] = useState('');
  const [email, setEmail] = useState((currentUser && currentUser.email) || '');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  useEffect(() => { if (!loading && company) navigate('/business/rides', { replace: true }); }, [loading, company, navigate]);
  if (!loading && company) return null;
  const create = async (e) => {
    e.preventDefault(); setErr(''); setBusy(true);
    try { await bizApi('/business/company', { method: 'POST', body: { name, billing_email: email } }); navigate('/business/settings', { replace: true }); }
    catch (x) { setErr(x.message); } finally { setBusy(false); }
  };
  return (
    <BusinessLayout title="RideBuraq Business" subtitle="Book chauffeured rides for the people you travel with. Save your travelers once, pay with the company card, and get a receipt with the traveler's name on every ride.">
      {loading ? <p className="text-gray-300" role="status">Loading…</p> : (
        <form onSubmit={create} className={`${card} max-w-xl space-y-6`} data-testid="create-company">
          <h2 className="text-xl font-semibold">Create your business account</h2>
          <label className="block text-sm text-gray-300">Company name
            <input data-testid="company-name-input" value={name} onChange={(e) => setName(e.target.value)} maxLength={200} required className={fieldCls} autoComplete="organization" />
          </label>
          <label className="block text-sm text-gray-300">Billing email
            <input data-testid="billing-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} maxLength={200} required className={fieldCls} autoComplete="email" />
          </label>
          {(err || error) && <p role="alert" className="text-base text-red-300" data-testid="biz-error">{err || error}</p>}
          <button type="submit" disabled={busy || !name.trim()} className={primaryBtn} data-testid="create-company-btn">{busy ? 'Creating…' : 'Create account'}</button>
        </form>
      )}
    </BusinessLayout>
  );
}
